import { DevPermission } from './types';

export const devPermissionOptions = [
  {
    text: 'Default Permissions',
    value: DevPermission.Default,
  },
  {
    text: 'Enable All Permissions',
    value: DevPermission.ForceEnable,
  },
  {
    text: 'Disable All Permissions',
    value: DevPermission.ForceDisable,
  },
];
